export default function Step5() {
    return (
        <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M20 18.2939C26.6274 18.2939 32 15.6077 32 12.2939C32 8.98024 26.6274 6.29395 20 6.29395C13.3726 6.29395 8 8.98024 8 12.2939C8 15.6077 13.3726 18.2939 20 18.2939Z"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M8 22.2939C8 25.6077 13.3726 28.2939 20 28.2939" stroke="black" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8 32.2939C8 35.6077 13.3726 38.2939 20 38.2939" stroke="black" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8 12.2939V32.2939" stroke="black" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M32 12.2939V17.2939" stroke="black" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M32.0018 29.7939C36.0802 29.7939 39.3864 28.115 39.3864 26.0439C39.3864 23.9729 36.0802 22.2939 32.0018 22.2939C27.9234 22.2939 24.6172 23.9729 24.6172 26.0439C24.6172 28.115 27.9234 29.7939 32.0018 29.7939Z"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M24.6172 32.2939C24.6172 34.365 27.9234 36.0439 32.0018 36.0439C36.0802 36.0439 39.3864 34.365 39.3864 32.2939"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M24.6172 38.5439C24.6172 40.615 27.9234 42.2939 32.0018 42.2939C36.0802 42.2939 39.3864 40.615 39.3864 38.5439"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M24.6172 26.0439V38.5439" stroke="black" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M39.3867 26.0439V38.5439" stroke="black" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
